export const fontImportMap: Record<string, () => Promise<any>> = {
  suecahd400: () => import("../assets/Sueca/Sueca Hd/400.css"),
  suecahd500: () => import("../assets/Sueca/Sueca Hd/500.css"),
  suecahd600: () => import("../assets/Sueca/Sueca Hd/600.css"),
  suecahd700: () => import("../assets/Sueca/Sueca Hd/700.css"),
  suecanano300: () => import("../assets/Sueca/Sueca Nano/300.css"),
  suecanano400: () => import("../assets/Sueca/Sueca Nano/400.css"),
  suecanano500: () => import("../assets/Sueca/Sueca Nano/500.css"),
  suecanano600: () => import("../assets/Sueca/Sueca Nano/600.css"),
  suecanano700: () => import("../assets/Sueca/Sueca Nano/700.css"),
  suecanano800: () => import("../assets/Sueca/Sueca Nano/800.css"),
  inter400: () => import("@fontsource/inter/400.css"),
  inter500: () => import("@fontsource/inter/500.css"),
  inter600: () => import("@fontsource/inter/600.css"),
  roboto300: () => import("@fontsource/roboto/300.css"),
  roboto400: () => import("@fontsource/roboto/400.css"),
  roboto500: () => import("@fontsource/roboto/500.css"),
  roboto700: () => import("@fontsource/roboto/700.css"),
  lato400: () => import("@fontsource/lato/400.css"),
  lato700: () => import("@fontsource/lato/700.css"),
  merriweather400: () => import("@fontsource/merriweather/400.css"),
  merriweather700: () => import("@fontsource/merriweather/700.css"),
  merriweather900: () => import("@fontsource/merriweather/900.css"),
  jost400: () => import("@fontsource/jost/400.css"),
  jost500: () => import("@fontsource/jost/500.css"),
  jost600: () => import("@fontsource/jost/600.css"),
};
